import { useState } from 'react';

import type { PetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';

type DecisionMakerType = PetitionEditPageState['formState']['decisionMakers']['value'][number];
type ViewMode = 'EDITING' | 'READONLY' | 'CREATING';
type UseSelectedDecisionMakerReturn = ModelHookResult<
	{
		viewMode: ViewMode;
	},
	{
		setViewMode: (mode: ViewMode) => void;
	}
>;
export function useSelectedDecisionMaker(decisionMaker: DecisionMakerType): UseSelectedDecisionMakerReturn {
	const [viewModeValue, setViewModeValue] = useState<ViewMode>(setViewModeByDecisionMakerId(decisionMaker.id));
	const setViewMode = (mode: ViewMode) => {
		setViewModeValue(mode);
	};
	return {
		data: {
			viewMode: viewModeValue,
		},
		actions: {
			setViewMode,
		},
	};
}

// ID scenarios
// * Int: from initial page query
// * String number (eg. '123'): for DM retrieved from search service
// * String (eg. 'temp-id...'): for creating new DM

// The only value that is unique to set the view to CREATING is the 'temp-id...'
function setViewModeByDecisionMakerId(id: string | number): ViewMode {
	if (Number.isInteger(Number(id))) return 'READONLY';
	return 'CREATING';
}
